import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import './style.scss';

// HRS stands for High Risk Supplements
const HRSSearchListEmptyCard: FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box className="hrs-search-list-blank-card__section">
      <Box className="hrs-search-list-blank-card__icon">
        <Box component="img" src="/images/img-list-alt-empty.svg" />
      </Box>
      <p className="hrs-search-list-blank-card__title">
        {t('highRiskSupplements.noSearchResults')}
      </p>
      <p className="hrs-search-list-blank-card__text">
        {t('highRiskSupplements.emptySearchCardNotification')}
      </p>
    </Box>
  );
};

export default HRSSearchListEmptyCard;
